import React, { useState, useEffect } from "react";
import { ComboBox } from "@progress/kendo-react-dropdowns";
import { useTranslation } from "react-i18next";

const Transforming = ({ selectedSensorIndex, device, setDevice, setOpen }) => {
  const operationData = ["+", "-", "*", "/", "%"];

  const defaultform = {
    operation: "",
    value: "",
    example: "",
  };
  const [selectedSensor, setSelectedSensor] = useState(defaultform);

  const [value, setValue] = useState(defaultform);
  const { t } = useTranslation();
  const handleOperationChange = (event) => {
    const selectedValue = event.target.value;
    setValue({ ...value, operation: selectedValue });
  };

  const onValueChange = (e) => {
    const { name, value } = e.target;
    setValue((prev) => ({
      ...prev,
      [name]: value,
      example: `[sensorData] ${prev.operation} ${value} `,
    }));
  };

  const onCloseClick = () => {
    setOpen(false);
  };

  const onSaveClick = () => {
    setDevice((pre) => ({
      ...pre,
      sensors: pre.sensors.map((s, index) =>
        index === selectedSensorIndex ? { ...s, transforms: value } : s
      ),
    }));
    setOpen(false);
  };

  const handleResetClick = () => {
    setValue(defaultform);
  };

  useEffect(() => {
    const sensor = device.sensors.find(
      (_, index) => index === selectedSensorIndex
    );
    setSelectedSensor(sensor);
    if (sensor && sensor.transforms) setValue(sensor.transforms);
  }, []);

  return (
    <div className="w-full h-full dark:bg-neutral-900 bg-zinc-300 rounded-lg p-5">
      <h2 className="text-2xl font-bold mb-4 dark:text-white text-black">
        {selectedSensor.name} - {t("button.transform")}
      </h2>
      <div className="flex flex-col gap-4 dark:text-white text-black">
        <div className="flex gap-6 items-center justify-between">
          <label className="dark:text-white text-black text-sm font-medium">
            {t("masters.fields.operations")}
          </label>
          <div className="w-40 lg:w-80">
            <ComboBox
              data={operationData}
              // dataItemKey="id"
              // textField="value"
              name="operations"
              suggest={true}
              clearButton={false}
              style={{
                fontSize: "12px",
                fontWeight: "500",
                paddingLeft: "20px",
              }}
              className="block placeholder:text-white border-grey-light dark:text-white text-black rounded-lg w-full h-9"
              onChange={handleOperationChange}
              value={value?.operation}
            />
          </div>
        </div>
        <div className="flex items-center justify-between">
          <label className="dark:text-white text-black text-sm font-medium">
            {t("masters.fields.value")}
          </label>
          <div className="w-40 lg:w-80">
            <input
              type="text"
              name="value"
              value={value && value.value}
              onChange={onValueChange}
              className="block placeholder:text-white border-grey-light rounded-lg dark:bg-[#363945] bg-zinc-400 to-zinc-600 dark:text-white text-black w-full h-9 px-5"
            />
          </div>
        </div>
        <div className="flex items-center justify-between">
          <label className="dark:text-white text-black text-sm font-medium">
            {t("masters.fields.example")}
          </label>
          <div className="w-40 lg:w-80">
            <input
              type="text"
              name="example"
              value={value && value.example}
              onChange={onValueChange}
              className="block placeholder:text-white border-grey-light rounded-lg dark:bg-[#363945] bg-zinc-400 to-zinc-600 dark:text-white text-black w-full h-9 px-5"
            />
          </div>
        </div>
      </div>
      <div className="flex items-center justify-end mt-8">
        <button
          type="button"
          name="reset"
          onClick={handleResetClick}
          className="text-white bg-red-500 text-xs lg:text-sm rounded-4xl px-auto py-auto lg:w-20 h-7 mr-2"
        >
          {t("button.reset")}
        </button>
        <button
          type="button"
          name="create"
          onClick={onCloseClick}
          className="text-black bg-white text-xs lg:text-sm rounded-4xl px-auto py-auto lg:w-20 h-7 mr-2"
        >
          {t("button.close")}
        </button>
        <button
          type="button"
          name="create"
          onClick={onSaveClick}
          className="text-white bg-indigo-700 text-xs lg:text-sm rounded-4xl px-auto py-auto lg:w-20 h-7"
        >
          {t("button.save")}
        </button>
      </div>
    </div>
  );
};

export default Transforming;
